export default __webpack_public_path__ + "static/media/merve1.e9132119.jpg";